import { QimaColorService } from '@aca-new/app/shared/services/exported-services/qima-color/qima-color.service';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { EQimaBadgeSize, EQimaBadgeStyle, EQimaIconName, QimaOptionalType, QimaResponsiveService } from '@qima/ngx-qima';
import { has } from 'lodash/index';

@UntilDestroy()
@Component({
  standalone: false,
  selector: 'app-aside-item',
  templateUrl: './aside-item.component.html',
  styleUrls: ['./aside-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class AsideItemComponent implements OnInit, OnChanges {
  /**
   * @description
   * The name of the icon to display
   * @type {EQimaIconName}
   * @default undefined
   */
  @Input('iconName')
  public iconName: QimaOptionalType<EQimaIconName> = undefined;

  /**
   * @description
   * The label of the aside common item
   * @type {string}
   * @default ''
   */
  @Input('label')
  public label: string = '';

  /**
   * @description
   * Check or not
   * @type {boolean}
   * @default false
   */
  @Input('isAsideItemChecked')
  public isChecked: boolean = false;

  /**
   * @description
   * Collapsed or not
   * @type {boolean}
   * @default false
   */
  @Input('isAsideItemCollapsed')
  public isCollapsed: boolean = false;

  /**
   * @description
   * The notification text to display
   * @type {QimaOptionalType<string>}
   * @default undefined
   */
  @Input('asideItemNotification')
  public notification: QimaOptionalType<string> = undefined;

  @Output('asideItemClick')
  public readonly asideItemClick: EventEmitter<MouseEvent | Event> = new EventEmitter<MouseEvent | Event>();

  public isMobile: boolean = false;
  public badgeSizeSmall = EQimaBadgeSize.SMALL;
  public badgeSizeMedium = EQimaBadgeSize.MEDIUM;
  public badgeStyle = EQimaBadgeStyle.CABBAGE;

  public constructor(
    public readonly qimaColor: QimaColorService,
    private readonly _qimaResponsiveService: QimaResponsiveService,
    private readonly _changeDetectorRef: ChangeDetectorRef
  ) {}

  public ngOnInit(): void {
    this._watch();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (has(changes, 'notification') && changes['notification'].currentValue !== changes['notification'].previousValue) {
      this.notification = changes['notification'].currentValue;
      this._changeDetectorRef.markForCheck();
    }
  }

  public onClick(event: Readonly<MouseEvent>): void {
    this._emitClick(event);
  }

  public onEnter(event: Readonly<Event>): void {
    this._emitClick(event);
  }

  private _emitClick(event: Readonly<MouseEvent | Event>): void {
    this.asideItemClick.emit(event);
  }

  private _watch(): void {
    this._qimaResponsiveService
      .isMobile$()
      .pipe(untilDestroyed(this))
      .subscribe((isMobile: boolean): void => {
        this.isMobile = isMobile;
        this._changeDetectorRef.markForCheck();
      });
  }
}
